import { Outlet } from "react-router-dom";
import { useState, useEffect, useContext } from "react";

import { useNavigate } from "react-router-dom";
import useIdle from "../../hooks/useIdle";

import SocketContext from "../../contexts/SocketContext";

// import { useSocket } from "../../contexts/SocketContextG";

import useLogout from "../../hooks/useLogout";

import "./SessionTimeoutWrapper.css";

const SessionTimeoutWrapper = () => {
  const { socket } = useContext(SocketContext);
  // const { socket } = useSocket();
  const logout = useLogout();

  //Session Time Out States
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);

  // Session Timeout Handler
  const handleIdle = () => {
    setShowModal(true); //show modal
    setRemainingTime(30); //set 15 seconds as time remaining
  };
  const { isIdle } = useIdle({ onIdle: handleIdle, idleTime: 15 });

  //Timer useEffect
  useEffect(() => {
    let interval;
    if (isIdle && showModal) {
      interval = setInterval(() => {
        setRemainingTime(
          (prevRemainingTime) => (prevRemainingTime > 0 ? prevRemainingTime - 1 : 0) //reduces the second by 1
        );
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isIdle, showModal]);

  //Signout Function
  const signOut = async () => {
    setShowModal(false);
    socket.disconnect();
    await logout();
  };

  //Logout useEffect
  useEffect(() => {
    if (remainingTime === 0 && showModal) {
      // alert("Time out!");
      //   navigate("/login");
      signOut();
    }
  }, [remainingTime, showModal, navigate]); // this is responsoble for logging user out after timer is down to zero and they have not clicked anything

  //Session Timeout functions
  //   const handleLogOut = () => {
  //     setShowModal(false);
  //     navigate("/login");
  //   };
  const handleStayLoggedIn = () => {
    setShowModal(false);
  };
  const millisToMinutesAndSeconds = (millis) => {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  };

  return (
    <>
      {/* handle isIdle for the modal */}
      {isIdle && showModal && (
        <div className='modal'>
          <div className='modal-content'>
            <h2>Idle Timeout Warning</h2>
            <p>You are about to be logged out due to inactivity.</p>
            <br />
            Time remaining: {millisToMinutesAndSeconds(remainingTime * 1000)}
            <br />
            <div className='row'>
              <button className='btn btn-danger' onClick={signOut}>
                Logout
              </button>
              <button className='btn btn-primary ' onClick={handleStayLoggedIn}>
                Stay Logged In
              </button>
            </div>
          </div>
        </div>
      )}
      <Outlet />
    </>
  );
};

export default SessionTimeoutWrapper;
